<template>
  <ux-form
    ref="form"
    width="450px"
    :data="formData"
    :rules="rules"
    :colon="true"
    label-width="120px"
  >
    <ux-form-item
      v-if="mode !== 'adjust'"
      :label="$t('HT.subordinate.quota.selectAccount')"
      required
      prop="accountId"
    >
      <ux-select
        v-model="formData.accountId"
        :options="accountOptions"
        :props="{ label: 'label', value: 'value' }"
        :placeholder="$t('HT.subordinate.quota.selectAccountPlaceholder')"
      ></ux-select>
    </ux-form-item>
    <ux-form-item
      :label="
        mode === 'adjust'
          ? $t('HT.subordinate.quota.adjustedQuota')
          : $t('HT.subordinate.quota.allocatedQuota')
      "
      required
      prop="amount"
    >
      <ux-input
        v-model="formData.amount"
        type="number"
        :placeholder="
          mode === 'adjust'
            ? $t('HT.subordinate.quota.adjustedQuotaPlaceholder')
            : $t('HT.subordinate.quota.quotaPlaceholder')
        "
      ></ux-input>
      <!-- <p v-if="mode === 'adjust' && account" class="form-hint">
        当前已分配 {{ formatQuota(account.allocated_quota) }} 万次，调整后不能低于已使用量
      </p> -->
      <p class="form-hint">
        {{
          $t('HT.subordinate.quota.availableBalanceHint', {
            quota: formatQuota(availableBalance)
          })
        }}
      </p>
    </ux-form-item>
    <ux-form-item :label="$t('HT.subordinate.common.remark')" prop="remark">
      <ux-input
        v-model="formData.remark"
        type="textarea"
        :maxlength="100"
        :placeholder="$t('HT.subordinate.quota.remarkPlaceholder')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  name: 'QuotaAllocationModal',
  props: {
    // 可分配的下级账号列表
    accounts: { type: Array, default: () => [] },
    // 弹窗操作模式：分配或调整
    mode: { type: String, default: 'allocate' },
    // 当前一级账号可用余额
    availableBalance: { type: Number, default: 0 },
    // 调整模式下的当前账号
    account: { type: Object, default: null }
  },
  data() {
    // 校验分配配额为正整数且不超过当前一级可用余额
    const validateAmount = (rule, value, callback) => {
      const amount = Number(value);
      if (!Number.isInteger(amount) || amount <= 0) {
        callback(new Error(this.$t('HT.subordinate.quota.positiveInteger')));
        return;
      }
      if (amount > Number(this.availableBalance)) {
        callback(new Error(this.$t('HT.subordinate.quota.exceedAvailableBalance')));
        return;
      }
      callback();
    };
    return {
      formData: {
        // 当前分配配额的子账号 ID
        accountId: '',
        amount: '',
        remark: ''
      },
      rules: {
        accountId: [
          {
            required: true,
            message: this.$t('HT.subordinate.quota.selectAccountPlaceholder'),
            trigger: 'change'
          }
        ],
        amount: [{ required: true, validator: validateAmount, trigger: 'blur' }],
        remark: [
          {
            max: 100,
            message: this.$t('HT.subordinate.common.remarkMaxLength'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    accountOptions() {
      return this.accounts.map((item) => ({
        label: `${item.name}（${item.level}）`,
        value: item.id
      }));
    }
  },
  methods: {
    // 格式化弹窗中的配额提示
    formatQuota(value) {
      return Number(value || 0).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.form-hint {
  margin: 4px 0 0;
  color: #929baa;
  font-size: 12px;
  line-height: 18px;
}
</style>
